import { useApolloClient } from '@apollo/client'
import { CompleteEmployeelifecycleStepActionDocument } from 'generated/resources/graphql'
import { InboxTaskListItemCompletionFragmentDoc } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

type CompleteStepActionTaskParams = {
  stepActionId: string
  taskId: string
}

export const useCompleteStepActionTask = () => {
  const apolloClient = useApolloClient()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const [completeStepActionTask] = useMutation(CompleteEmployeelifecycleStepActionDocument, {
    extractorFn: (data) => data.employeeLifecycleMutations.completeEmployeelifecycleStepAction,
  })

  return async ({ stepActionId, taskId }: CompleteStepActionTaskParams) => {
    const cacheId = `TasksInboxTask:${taskId}`
    const previousTaskData = apolloClient.readFragment({
      id: cacheId,
      fragment: InboxTaskListItemCompletionFragmentDoc,
      fragmentName: 'InboxTaskListItemCompletion',
    })

    apolloClient.writeFragment({
      id: cacheId,
      fragment: InboxTaskListItemCompletionFragmentDoc,
      fragmentName: 'InboxTaskListItemCompletion',
      data: {
        __typename: 'TasksInboxTask',
        id: taskId,
        completedAt: new Date().toISOString(),
        status: 'done',
      },
    })

    try {
      await completeStepActionTask({
        variables: {
          companyId,
          id: stepActionId,
        },
      })
    } catch (error) {
      if (previousTaskData) {
        apolloClient.writeFragment({
          id: cacheId,
          fragment: InboxTaskListItemCompletionFragmentDoc,
          fragmentName: 'InboxTaskListItemCompletion',
          data: previousTaskData,
        })
      }

      throw error
    }
  }
}
